<template>
  <pt-all-audit class="pt-all-audit__withData" @exportMedicalRewardList="exportMedicalRewardList" @exportAllAudit="exportAllAudit" :departmentList="departmentList"></pt-all-audit>
</template>

<script>
import PtAllAudit from './index'
export default {
  name: 'pt-all-audit__withData',
  components: {
    'pt-all-audit': PtAllAudit
  },
  data () {
    return {
      exportLoading: false,
      departmentList: []

    }
  },
  methods: {
    // 获取业务部列表
    getBusinessDepartment () {
      this.$store.dispatch('getBusinessDepartment').then(res => {
        this.departmentList = res
      }).catch(err => {
        this.$message.error(err || '获取事业部列表失败')
      })
    },
    exportAllAudit (data) {
      this.exportLoading = true
      this.$store.dispatch('exportAUditAll', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出奖励汇总列表失败')
      })
    },
    exportMedicalRewardList (data) {
      this.exportLoading = true
      for (let key in data) {
        if (!data[key]) {
          this.$delete(data, key)
        }
      }
      this.$store.dispatch('exportMedicalRewardList', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出奖励汇总列表失败')
      })
    }
  },
  created () {
    this.getBusinessDepartment()
  }
}
</script>
